import classNames from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Typography } from '../v2/Typography/Typography';

import './sideMenuItem.scss';

type SideMenuItemProps = {
  renderIcon: () => React.ReactNode;
  renderSelectedIcon: () => React.ReactNode;
  onClick?: () => void;
  text: string;
  link?: string;
  expanded: boolean;
  selected: boolean;
  display?: boolean;
  bubbleText?: string;
  bubbleColor?: string;
};
export const SideMenuItem = (props: SideMenuItemProps) => {
  const navigate = useNavigate();
  const { renderIcon, renderSelectedIcon, text, link, expanded, selected, display = true } =
    props;

  if (!display) {
    return null;
  }

  return (
    <div
      className={classNames('SideMenuItem-root relative', {
        'SideMenuItem--selected': selected,
        'px-[19px] expanded': expanded,
        'justify-center items-center': !expanded
      })}
      onClick={() => (link ? navigate(link) : props.onClick && props.onClick())}
    >
      {selected ? (
        <div className='w-5 flex justify-center items-center'>
          {renderSelectedIcon && renderSelectedIcon()}
        </div>
      ) : (
        <div className='w-5 flex justify-center items-center'>
          {renderIcon && renderIcon()}
        </div>
      )}

      {expanded && (
        <Typography
          className='ml-[18px] '
          variant='functional-low'
          type='body-400'
        >
          <>{text}
          {props.bubbleText && (
            <span
              className='px-2 py-1 rounded-full absolute top-[50%] translate-y-[-50%] right-0 text-xs font-semibold'
              style={{ backgroundColor: props.bubbleColor || '#cac8d3' }}
            >
              {props.bubbleText}
            </span>
          )}
          </>
        </Typography>
      )}
    </div>
  );
};
